export const SET_FEEDBACK_LOCATION_LOADING = "SET_FEEDBACK_LOCATION_LOADING";
export const SET_FEEDBACK_LOCATION = "SET_FEEDBACK_LOCATION";
export const EDIT_FEEDBACK_LOCATION = "EDIT_FEEDBACK_LOCATION";

export const ADD_FEEDBACK_LOCATION = "ADD_FEEDBACK_LOCATION";
export const DELETE_DEVICES = "DELETE_DEVICES";

export const SET_FEEDBACK_FILTER_CAMPAIGN = "SET_FEEDBACK_FILTER_CAMPAIGN";
